import { envConfigSelectors } from '~/selectors';
import { SelectDateTime } from '~/routes';

export const config = {
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
